import React from 'react';

export default function JobIllustration({ job, hero = false }) {
  const bible = job.kind === 'bible';
  return (
    <img
      className={hero ? 'jobs-hero-image' : 'jobs-card-image'}
      src={bible ? `/static/images/gal-ezekiel/chapter-${job.chapter}.webp` : `/static/images/sermon/${job.slug}.png`}
      alt={hero ? `${bible ? 'エゼキエル書 ' : '説教「'}${job.label}${bible ? '' : '」'}の挿絵` : ''}
      width={bible ? 1120 : 1254}
      height={bible ? 747 : 1254}
      loading={hero ? 'eager' : 'lazy'}
      decoding="async"
    />
  );
}
